<template>
  <div>
    <!-- <el-dialog
      :close-on-click-modal="false"
      width="90%"
      title="添加商品"
      :visible="visible"
      @close="close"
    > -->
    <div class="mb10">
      <el-radio-group v-model="goodsType" size="small" @change="switchTab">
        <el-radio-button label="category">关联品类</el-radio-button>
        <el-radio-button label="brand" :disabled="params.type === 'brand'"
          >关联品牌</el-radio-button
        >
        <el-radio-button label="attribute">关联属性</el-radio-button>
        <el-radio-button label="goods" :disabled="params.type === 'goods'"
          >关联商品
        </el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <el-scrollbar
        ref="scrollContainer"
        :vertical="false"
        v-show="goodsType === 'category'"
        wrap-style="height: 420px;"
      >
        <el-tree
          v-show="goodsType === 'category'"
          empty-text="暂无品类"
          :props="props"
          :load="loadNode"
          node-key="id"
          ref="tree"
          :check-strictly="true"
          highlight-current
          lazy
          show-checkbox
          @node-click="nodeClick"
        ></el-tree>
        <!-- @check-change="handleCheckChange" -->
      </el-scrollbar>
      <el-scrollbar
        ref="scrollContainer"
        :vertical="false"
        v-show="goodsType === 'attribute'"
        wrap-style="height: 420px;"
      >
        <el-tree
          v-show="goodsType === 'attribute'"
          empty-text="暂无属性"
          :props="props"
          :load="loadNodeAttr"
          node-key="id"
          ref="treeAttr"
          :check-strictly="true"
          highlight-current
          lazy
          show-checkbox
          @node-click="nodeClick"
        ></el-tree>
        <!-- @check-change="handleCheckChange" -->
      </el-scrollbar>
      <!-- <el-cascader
          :check-strictly="true"
          v-if="goodsType === 'goods'"
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader> -->
      <!-- <el-select
          v-if="goodsType !== 'category'"
          filterable
          clearable
          size="small"
          class="mr10 flex-1"
          v-model="searchCondition.brandId"
          placeholder="请选择商品品牌"
        >
          <el-option
            :label="v.brandName"
            :value="v.brandId"
            v-for="(v, i) in allBrandList"
            :key="i"
          ></el-option>
        </el-select> -->
      <el-input
        clearable
        v-if="goodsType === 'brand'"
        v-model.trim="searchCondition.brandName"
        size="small"
        style="width:300px"
        placeholder="搜索品牌"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        v-if="goodsType === 'goods'"
        style="width: 300px"
        v-model.trim="searchCondition.spuName"
        size="small"
        placeholder="搜索商品名"
        class="ipt mr10"
      >
        <!-- <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            @change="selectQueryType"
            v-model="searchCondition.queryType"
          >
            <el-option label="商品名" value="spu_name"></el-option>
            <el-option label="货号" value="goods_sn"></el-option>
            <el-option label="条码" value="spec_barcode"></el-option>
            <el-option label="品牌名" value="brand_name"></el-option>
          </el-select> -->
      </el-input>
      <el-input
        clearable
        v-if="goodsType === 'goods'"
        style="width: 300px"
        v-model.trim="searchCondition.goodsSn"
        size="small"
        placeholder="搜索货号"
        class="ipt mr10"
      >
      </el-input>
      <el-button
        v-if="goodsType !== 'category' && goodsType !== 'attribute'"
        type="primary"
        size="small"
        @click="search"
        >查询</el-button
      >
    </div>
    <!-- <div
        class="flex flex-end"
        v-if="goodsType === 'goods'"
        style="marginBottom:-20px"
      >
        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入商品
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div> -->
    <div class="mt10" v-if="goodsType === 'brand'">
      <!-- <div class="form-item-tip" style="color:red">
        点击需要选中的品牌
      </div> -->
      <el-table
        stripe
        border
        ref="brandTable"
        :data="list"
        @current-change="handleCurrentChange"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          key="brandName"
          label="品牌名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          prop="brandLogo"
          label="品牌logo图"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.brandLogo"
              alt
              style="width:60px;height:60px"
              v-if="scope.row.brandLogo"
            />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandAcronym"
          label="品牌首字母"
          key="brandAcronym"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div class="mt10" v-if="goodsType === 'goods'">
      <!-- <div class="form-item-tip" style="color:red">
        点击需要选中的商品
      </div> -->
      <el-table
        stripe
        border
        ref="brandTable"
        :data="list"
        @current-change="handleCurrentChange"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          key="spuName"
          show-overflow-tooltip
          label="商品名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          key="goodsSn"
          label="商品货号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          key="brandName"
          label="品牌"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total, sizes,  prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- <div class="flex item-center hm-transfer-goods ">
        <div class="table">
          <div class="table-out-header flex flex-between">
            <div class="flex-1">
              <el-checkbox
                :indeterminate="leftIsIndeterminate"
                :disabled="leftData.length <= 0"
                v-model="leftCheckAll"
                @change="handleLeftCheckAllChange"
                style="float: left"
                >全选</el-checkbox
              >
            </div>
            <div class="transfer-title flex-2 text-center">可选范围</div>
          </div>
          <div
            class="table-header flex flex-between"
            v-if="goodsType === 'category'"
          >
            <div class="flex-1 num">关联类型</div>
            <div class="flex-1 name">品类名称</div>
            <div class="flex-1 name ">品类编码</div>
          </div>
          <div
            class="table-header flex flex-between"
            v-if="goodsType === 'brand'"
          >
            <div class="flex-1 num">关联类型</div>
            <div class="flex-1 name ">品牌名称</div>
            <div class="flex-1 name ">品牌编码</div>
          </div>
          <div
            class="table-header flex flex-between"
            v-if="goodsType === 'goods'"
          >
            <div class="flex-1 num">关联类型</div>
            <div class="flex-1 name">品类名称</div>
            <div class="flex-1 name ">品类编码</div>
            <div class="flex-1 name ">品牌名称</div>
            <div class="flex-1 name ">品牌编码</div>
            <div class="flex-1 name ">商品名称</div>
            <div class="flex-1 name text-center">商品编码</div>
            <div class="flex-1 name text-center">商品价格</div>
          </div>

          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="height: 400px;"
            >
              <el-checkbox-group
                v-model="leftChecked"
                @change="handleLeftCheckedChange"
              >
                <div
                  v-for="(v, i) in leftData"
                  :key="i"
                  class="check-wrapper flex item-center"
                  :title="v.promotionName"
                >
                  <div class="flex-4">
                    <el-checkbox
                      :label="v"
                      class="flex"
                      v-if="goodsType === 'category'"
                    >
                      <span class="flex-1 attrid">品类</span>

                      <span class="flex-1 goods-name">{{ v.name }}</span>

                      <el-tooltip :content="v.spuId" placement="top">
                        <span class="flex-1 goods-name">{{ v.spuId }}</span>
                      </el-tooltip>
                    </el-checkbox>
                    <el-checkbox
                      :label="v"
                      class="flex"
                      v-if="goodsType === 'brand'"
                    >
                      <span class="flex-1 attrid">品牌</span>

                      <span class="flex-1 goods-name">{{ v.brandName }}</span>

                      <el-tooltip :content="v.spuId" placement="top">
                        <span class="flex-1 goods-name">{{ v.spuId }}</span>
                      </el-tooltip>
                    </el-checkbox>
                    <el-checkbox
                      :label="v"
                      class="flex"
                      v-if="goodsType === 'goods'"
                    >
                      <span class="flex-1 attrid">商品</span>
                      <el-tooltip :content="v.categoryName" placement="top">
                        <span class="flex-1 goods-name">{{
                          v.categoryName
                        }}</span>
                      </el-tooltip>

                      <el-tooltip :content="v.categoryId" placement="top">
                        <span class="flex-1 goods-name">{{
                          v.categoryId
                        }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.brandName" placement="top">
                        <span class="flex-1 goods-name">{{ v.brandName }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.brandId" placement="top">
                        <span class="flex-1 goods-name">{{ v.brandId }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.spuName" placement="top">
                        <span class="flex-1 goods-name">{{ v.spuName }}</span>
                      </el-tooltip>
                      <el-tooltip
                        :content="v.goodsSnAndBarcode"
                        placement="top"
                      >
                        <span class="flex-1 goods-name text-center">{{
                          v.goodsSnAndBarcode
                        }}</span>
                      </el-tooltip>

                      <span class="flex-1 goods-name text-center">{{
                        v.recommendedRetailPrice
                      }}</span>
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div class="hm-pagination" v-if="goodsType !== 'category'">
              <el-pagination
                background
                :total="total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total,  prev, pager, next"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>


        <div class="flex flex-column control text-center">
          <div class="mb20">操作</div>

          <el-button
            size="small"
            class="hmicon icon-youshuangjiantou1"
            @click="allToRight"
            :disabled="leftData.length <= 0"
          ></el-button>
          <el-button
            size="small"
            class="hmicon icon-youjiantou"
            @click="toRight"
            :disabled="leftData.length <= 0 || leftChecked.length <= 0"
          ></el-button>
          <el-button
            size="small"
            class="hmicon icon-zuoshuangjiantou1"
            @click="allToLeft"
            :disabled="rightData.length <= 0"
          ></el-button>
          <el-button
            size="small"
            class="hmicon icon-zuojiantou"
            @click="toLeft"
            :disabled="rightData.length <= 0 || rightChecked.length <= 0"
          ></el-button>

        </div>

        <div class="table">
          <div class="table-out-header flex flex-between">
            <div class="flex-1">
              <el-checkbox
                :indeterminate="rightIsIndeterminate"
                :disabled="rightData.length <= 0"
                v-model="rightCheckAll"
                @change="handleRightCheckAllChange"
                style="float: left"
                >全选</el-checkbox
              >
            </div>
            <div class="transfer-title flex-2 text-center">已选范围</div>
          </div>
          <div
            class="table-header flex flex-between"
            v-if="goodsType === 'category'"
          >
            <div class="flex-1 num">关联类型</div>
            <div class="flex-1 name">品类名称</div>
            <div class="flex-1 name ">品类编码</div>
          </div>
          <div
            class="table-header flex flex-between"
            v-if="goodsType === 'brand'"
          >
            <div class="flex-1 num">关联类型</div>
            <div class="flex-1 name ">品牌名称</div>
            <div class="flex-1 name ">品牌编码</div>
          </div>
          <div
            class="table-header flex flex-between"
            v-if="goodsType === 'goods'"
          >
            <div class="flex-1 num">关联类型</div>
            <div class="flex-1 name">品类名称</div>
            <div class="flex-1 name ">品类编码</div>
            <div class="flex-1 name ">品牌名称</div>
            <div class="flex-1 name ">品牌编码</div>
            <div class="flex-1 name ">商品名称</div>
            <div class="flex-1 name text-center">商品编码</div>
            <div class="flex-1 name text-center">商品价格</div>
          </div>

          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="height: 443px;"
            >
              <el-checkbox-group
                v-model="rightChecked"
                @change="handleRightCheckedChange"
              >
                <div
                  v-for="(v, i) in rightData"
                  :key="i"
                  class="check-wrapper   item-center"
                >
                  <div class="flex-4">
                    <el-checkbox
                      :label="v"
                      class="flex"
                      v-if="goodsType === 'category'"
                    >
                      <span class="flex-1 attrid">品类</span>

                      <span class="flex-1 goods-name">{{ v.name }}</span>

                      <el-tooltip :content="v.spuId" placement="top">
                        <span class="flex-1 goods-name">{{ v.spuId }}</span>
                      </el-tooltip>
                    </el-checkbox>
                    <el-checkbox
                      :label="v"
                      class="flex"
                      v-if="goodsType === 'brand'"
                    >
                      <span class="flex-1 attrid">品牌</span>

                      <span class="flex-1 goods-name">{{ v.brandName }}</span>

                      <el-tooltip :content="v.spuId" placement="top">
                        <span class="flex-1 goods-name">{{ v.spuId }}</span>
                      </el-tooltip>
                    </el-checkbox>
                    <el-checkbox
                      :label="v"
                      class="flex"
                      v-if="goodsType === 'goods'"
                    >
                      <span class="flex-1 attrid">商品</span>
                      <el-tooltip :content="v.categoryName" placement="top">
                        <span class="flex-1 goods-name">{{
                          v.categoryName
                        }}</span>
                      </el-tooltip>

                      <el-tooltip :content="v.categoryId" placement="top">
                        <span class="flex-1 goods-name">{{
                          v.categoryId
                        }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.brandName" placement="top">
                        <span class="flex-1 goods-name">{{ v.brandName }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.brandId" placement="top">
                        <span class="flex-1 goods-name">{{ v.brandId }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.spuName" placement="top">
                        <span class="flex-1 goods-name">{{ v.spuName }}</span>
                      </el-tooltip>
                      <el-tooltip
                        :content="v.goodsSnAndBarcode"
                        placement="top"
                      >
                        <span class="flex-1 goods-name text-center">{{
                          v.goodsSnAndBarcode
                        }}</span>
                      </el-tooltip>

                      <span class="flex-1 goods-name text-center">{{
                        v.recommendedRetailPrice
                      }}</span>
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
          </div>
        </div>
      </div> -->
    <div class="btn-wrapper mb20 flex flex-center mt10">
      <el-button size="small" type="primary" @click="saveGoods"
        >确 定</el-button
      >
      <el-button size="small" @click="close">取 消</el-button>
    </div>
    <!-- </el-dialog> -->
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据重复未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="spuId" label="重复货号"></el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    targeYear: {
      type: String,
      default: ""
    },
    params: {
      default: function() {
        return {};
      },
      type: Object
    }
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: 0,
      brandList: [],
      goodsList: [],
      errValidGoods: false,
      errInputResult: [],
      checkedCurrentRow: {},
      whitelistState: "white",
      isEnableSession: false,
      sendWayType: "",
      isChecked: false,
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      list: [],
      goodsType: "category",
      allBrandList: [],
      placeholder: "请输入商品名",
      searchCondition: {
        keyWords: "",
        queryType: "spu_name"
      },
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },

      props: {
        value: "id",
        label: "name",
        children: "children",
        isLeaf: "leaf"
      },
      checked: [],
      mon: {
        children: [],
        aaa: "aaa"
      },
      currentRow: {},
      haveCategoryList: [],
      haveAttributeList: [],
      multipleSelection: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.params.hasOwnProperty("children") && this.params.children.length) {
      this.haveCategoryList = [];
      this.haveAttributeList = [];
      this.params.children.forEach(v => {
        if (v.type === "category") {
          this.haveCategoryList.push(v.id);
        } else if (v.type === "attribute") {
          this.haveAttributeList.push(v.id);
        }
      });
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    nodeClick() {},
    handleCheckChange(data, checked) {
      let { id } = data;

      let index = this.checked.indexOf(id);
      // 当前节点不在this.checked中,且当前节点为选中状态
      if (index < 0 && this.checked.length && checked) {
        // this.$message.warning("只能选中一个节点");
        this.$message({
          message: "只能选中一个节点",
          type: "warning",
          duration: "1000"
        });
        // console.log(this.$refs.tree.setCheckedNodes([]));
        this.$refs.tree.setCheckedNodes([]);
        this.$refs.treeAttr.setCheckedNodes([]); // 取消当前节点的选中状态
        // 取消当前节点的选中状态
        return;
      }
      // 当前节点在this.checked中,当前节点为未选中状态(主动去掉当前选中状态)
      if (!checked && index >= 0 && this.checked.length) {
        this.checked = [];
        return;
      }
      // 当前节点不在this.checked(长度为0)中,当前节点为选中状态,this.checked中存储当前节点id
      if (index < 0 && !this.checked.length && checked) {
        this.checked.push(id);
      }
    },
    loadNodeAttr(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestAttrTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getAttrIndex(node, resolve);
      }
    },
    requestAttrTree(resolve) {
      let params = {
        timeType: "year",
        timeValue: this.targeYear
      };
      Object.assign(params, this.params);

      this.$store
        .dispatch("getOrkAttributeList", params)
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            if (
              this.haveAttributeList.findIndex(o => o === v.attributeId) >= 0
            ) {
              v.disabled = true;
            }
            v.id = v.attributeId;
            v.type = "attribute";
            v.name = v.attributeName;
          });

          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    getAttrIndex(node, resolve) {
      let params = {
        timeType: "year",
        timeValue: this.targeYear
      };
      Object.assign(params, this.params);
      params.attributeId = node.data.attributeId;
      // let name = "";
      // if (this.goodsType === "category") {
      //   params.categoryId = node.data.categoryId;
      //   name = "getOrkCategoryList";
      // } else if (this.goodsType === "attribute") {
      //   name = "getOrkAttributeList";
      // }

      this.$store
        .dispatch("getOrkAttributeNodeList", params)
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            if (node.data.disabled) {
              v.disabled = true;
            }
            v.id = v.attributeId;
            v.type = "attribute";
            v.name = v.attributeName;
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    loadNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    // 首次加载一级节点数据函数
    requestTree(resolve) {
      let params = {
        // categoryId: "",
        // timeType: "year",
        // timeValue: this.targeYear
      };

      Object.assign(params, this.params);

      this.$store
        .dispatch("getOrkCategoryList", params)
        .then(res => {
          const data = res.result;

          data.forEach(v => {
            if (this.haveCategoryList.findIndex(o => o === v.categoryId) >= 0) {
              v.disabled = true;
            }

            v.id = v.categoryId;
            v.type = "category";
            v.name = v.categoryName;
          });

          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      let params = {
        // timeType: "year",
        // timeValue: this.targeYear
      };
      Object.assign(params, this.params);
      params.categoryId = node.data.categoryId;

      this.$store
        .dispatch("getOrkCategoryList", params)
        .then(res => {
          const data = res.result;

          data.forEach(v => {
            if (node.data.disabled) {
              v.disabled = true;
            }
            v.id = v.categoryId;
            v.type = "category";
            v.name = v.categoryName;
          });

          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },
    saveGoods() {
      if (this.goodsType === "category") {
        let checkCateGoryList = this.$refs.tree.getCheckedNodes();
        checkCateGoryList.forEach(data => {
          Object.assign(data, this.mon);
          data.goodsSn = "";
          data.brandId = "";
          data.attributeId = "";
        });
        this.$emit("saveGoods", checkCateGoryList);
        // if (checkCateGoryList.length === 1) {
        //   let data = checkCateGoryList[0];
        //   Object.assign(data, this.mon);
        //   data.goodsSn = "";
        //   data.brandId = "";
        //   data.attributeId = "";

        //   this.$emit("saveGoods", data);
        // } else {
        //   this.$message({
        //     message: "只能选中一个节点",
        //     type: "warning",
        //     duration: "1000"
        //   });
        // }
      } else if (this.goodsType === "attribute") {
        let checkCateGoryList = this.$refs.treeAttr.getCheckedNodes();
        checkCateGoryList.forEach(data => {
          Object.assign(data, this.mon);
          data.goodsSn = "";
          data.brandId = "";
          data.categoryId = "";
        });
        this.$emit("saveGoods", checkCateGoryList);
        // if (checkCateGoryList.length === 1) {
        //   let data = checkCateGoryList[0];
        //   Object.assign(data, this.mon);
        //   data.goodsSn = "";
        //   data.brandId = "";
        //   data.categoryId = "";

        //   this.$emit("saveGoods", data);
        // } else {
        //   this.$message({
        //     message: "只能选中一个节点",
        //     type: "warning",
        //     duration: "1000"
        //   });
        // }
      } else {
        if (this.goodsType === "goods") {
          // this.currentRow.brandId = "";
          // this.currentRow.categoryId = "";
          // this.currentRow.attributeId = "";
          this.multipleSelection.forEach(data => {
            Object.assign(data, this.mon);
            data.brandId = "";
            data.categoryId = "";
            data.attributeId = "";
          });
        } else {
          // this.currentRow.attributeId = "";
          // this.currentRow.goodsSn = "";
          // this.currentRow.categoryId = "";
          this.multipleSelection.forEach(data => {
            Object.assign(data, this.mon);
            data.attributeId = "";
            data.goodsSn = "";
            data.categoryId = "";
          });
        }
        console.log("this.multipleSelection: ", this.multipleSelection);
        // Object.assign(this.currentRow, this.mon);
        this.$emit("saveGoods", this.multipleSelection);
      }

      // if (this.rightData.length > 0) {
      //   let params = {
      //     goodsType: this.goodsType,
      //     rightData: this.rightData
      //   };
      //
      // } else {
      //   this.$message({
      //     message: "请选择商品",
      //     type: "warning"
      //   });
      // }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    // async queryAllBrand() {
    //   const { result } = await this.$store.dispatch("queryBrandAllList", {
    //     pageSize: 999999,
    //     pageNo: 1
    //   });
    //   this.allBrandList = result.records;
    // },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        timeType: "year",
        timeValue: this.targeYear
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      Object.assign(params, this.params);
      params.brandName = searchCondition.brandName;
      params.spuName = searchCondition.spuName;
      params.goodsSn = searchCondition.goodsSn;
      let actionName = "";
      if (this.goodsType === "goods") {
        actionName = "getOrkSpuList";
      } else if (this.goodsType === "brand") {
        actionName = "getOrkBrankList";
      }
      if (this.goodsType === "category") {
        const checkCateGoryList = this.$refs.tree.getCheckedNodes();
        this.leftData = checkCateGoryList || [];
      } else {
        const { result } = await this.$store.dispatch(actionName, params);

        const { records, total } = result;
        if (this.goodsType === "brand") {
          records.forEach(v => {
            v.name = v.brandName;
            v.type = "brand";
            v.id = v.brandId;
          });
        } else {
          records.forEach(v => {
            v.name = v.spuName;
            v.type = "goods";
            v.id = v.goodsSn;
          });
        }
        this.list = records;
        this.total = total;
        // if (this.goodsType === "brand") {
        //   result.records.forEach(v => {
        //     v.spuId = v.brandId;
        //   });
        // } else {
        //   result.records.forEach(v => {
        //     v.goodsSnAndBarcode = v.goodsSnAndBarcode.split("/")[0];
        //     v.spuId = v.goodsSnAndBarcode;
        //   });
        // }

        // this.total = result.total;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    switchTab(val) {
      this.leftData = [];
      this.rightData = [];
      this.multipleSelection = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.total = 0;
      this.$refs.tree.setCheckedNodes([]);
      this.$refs.treeAttr.setCheckedNodes([]);
      if (val !== "category" && val !== "attribute") {
        this.queryList();
      }
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftData
          //     })
          //     .then(res => {
          //       if (this.leftData.length > 0) {
          //         this.rightData = this.rightData.concat(res.result);
          //         this.rightData.forEach(v => {
          //           v.activityName = v.existActivity
          //             ? v.existActivity.map(item => item.promotionName)
          //             : [];
          //           v.activityStr = v.activityName.join(",");
          //           if (this.isMustDelivery) {
          //             v.isMustDelivery = this.isMustDelivery;
          //           }
          //         });
          //         this.leftData = [];
          //         this.leftChecked = [];
          //       }
          //       this.handleRightCheckAllChange(true);
          //       this.leftCheckAll = false;
          //       this.rightCheckAll = true;
          //     });
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
    },
    toRight() {
      // 移动选中到右边
      const result = this.checkCommon(this.leftChecked, this.rightData);
      if (!result) {
        // if (this.showUseable) {
        //   this.leftData.forEach(v => {
        //     v.whitelistState = this.whitelistState;
        //   });
        // }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          //   this.rightData.forEach(v => {
          //     if (this.isMustDelivery) {
          //       v.isMustDelivery = this.isMustDelivery;
          //     }
          //   });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v.spuId === this.leftChecked[0].spuId) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v.spuId === item.spuId) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);

      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (v.spuId === this.rightChecked[0].spuId) {
              this.rightData.splice(i, 1);
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (v.spuId === item.spuId) {
                this.rightData.splice(index, 1);
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.spuId) === String(item.spuId)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号"];
        const data = [];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];

        let isRequired = true;
        let goodsSns = [];
        if (result.length) {
          result.forEach(v => {
            if (!v[0]) {
              isRequired = false;
            } else {
              // goodsSns.push(v[0]);
              formatResult.push({
                spuId: v[0]
              });
            }
          });
          let object = {};
          let objres = formatResult.reduce((item, next) => {
            object[next.spuId]
              ? ""
              : (object[next.spuId] = true && item.push(next));
            return item;
          }, []);
          objres.forEach(v => {
            goodsSns.push(v.spuId);
          });
        } else {
          isRequired = false;
        }

        if (isRequired) {
          // let errList = formatResult.filter((item, index, self) => {
          //   for (let i = index + 1; i < self.length; i++) {
          //     if (self[i].spuId === item.spuId) {
          //       return true;
          //     }
          //   }
          //   return false;
          // });
          let errList = [];
          if (errList.length > 0) {
            that.errValidGoods = true;
            that.errInputResult = errList;
            that.$message({
              message: "导入失败，有重复商品货号！",
              type: "warning"
            });
          } else {
            let params = {
              goodsSnList: goodsSns
            };
            that.$store.dispatch("querySpuListGoodsSn", params).then(res => {
              const { code, result } = res;
              if (code === "0") {
                result.forEach(v => {
                  v.spuId = v.goodsSn;
                  v.goodsSnAndBarcode = v.spuId;
                });

                if (result.length > 0) {
                  that.rightData.forEach(v => {
                    result.forEach((item, index) => {
                      if (v.spuId === item.spuId) {
                        result.splice(index, 1);
                      }
                    });
                  });
                }

                that.rightData.push(...result);

                // if (result.resultList.length > 0) {
                //   that.distributionGoodList = [];
                //   result.resultList.forEach(v => {
                //     formatResult.forEach(item => {
                //       if (v.goodsSn === item.goodsSn) {
                //         that.distributionGoodList.push(
                //           Object.assign({}, item, v)
                //         );
                //       }
                //     });
                //   });
                // }
                // if (result.errGoodsSns.length > 0) {
                //   that.errValidGoods = true;
                //   that.errInputResult = [];
                //   result.errGoodsSns.forEach(v => {
                //     that.errInputResult.push({ goodsSn: v });
                //   });
                // }
              }
            });
          }
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，商品货号不能为空！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    }
    // arrayUnique2(arr, name) {
    //   var hash = {};
    //   return arr.reduce(function(item, next) {
    //     hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
    //     return item;
    //   }, []);
    // }
  }
};
</script>
<style lang="scss">
.hm-transfer-goods {
  .table-body {
    .check-wrapper {
      padding-left: 12px;
    }
    .el-checkbox {
      width: 100%;
    }

    .el-checkbox__label {
      width: calc(100% - 24px);
      display: flex;
    }
    .check-wrapper:nth-child(even) {
      background: #f7f7f7;
    }
  }
  .el-checkbox {
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  //   max-width: 500px;
  width: 700px;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      margin-left: 26px;
    }
    // .name {
    //   margin-left: -26px;
    // }
  }
  .table-body {
    font-size: 12px;

    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
  .goods-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    box-sizing: border-box;
    width: 30px;
  }
}

.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
  margin-left: 12px;
}
</style>
c
